import { Alert, Card, CardBody, Col, Row, Spinner } from "reactstrap";
import notFound from "../../assets/imgs/not-found.png";
import { PurchaseOrderDetailsHeader } from "../../components/Headers/Headers";
import NotesCard from "../../components/cards/NotesCard";
import OrderBillingAddressCard from "../../components/cards/OrderBillingAddressCard";
import OrderShippingAddressCard from "../../components/cards/OrderShippingAddressCard";
import PurchaseItemCard from "../../components/cards/PurchaseItemCard";
import PurchaseOrderInformations from "../../components/cards/PurchaseOrderInformations";
import PurchaseTotalCard from "../../components/cards/PurchaseTotalCard";

import AddOrderItem from "../../components/modals/AddOrderItem";
import PageName from "../../components/react_helmet/PageName";
import useUpdatePurchaseOrder from "./customHooks/useUpdatePurchaseOrder";
import POBasicInformations from "../../components/cards/POBasicInformations";
import moment from "moment";
import { FiFileText } from "react-icons/fi";
import OrderDetailsSkeleton from "../../components/skeleton/OrderDetailsSkeleton";

const BLIND_SHIPPING_DIRECTIVE = `************BLIND SHIPPING ONLY************\nPlease do NOT include any pricing on invoices, receipts, price tags, or promotional materials inside or outside the package`;

const isBlindShippingNotePresent = (text) => {
  if (!text) return false;
  return /\*+\s*BLIND SHIPPING ONLY\s*\*+/i.test(text);
};

const addBlindShippingNote = (text) => {
  if (isBlindShippingNotePresent(text)) return text;
  const trimmed = (text || "").trim();
  if (!trimmed) return BLIND_SHIPPING_DIRECTIVE;
  return `${BLIND_SHIPPING_DIRECTIVE}\n\n${trimmed}`;
};

const removeBlindShippingNote = (text) => {
  if (!text) return "";
  let cleaned = String(text)
    .replace(/\*+\s*BLIND SHIPPING ONLY\s*\*+[\s\S]*?(inside or outside the package\.?)/gi, "")
    .replace(/\*+\s*BLIND SHIPMENT DIRECTIVE:?[\s\S]*?(inside or outside the package\.?)/gi, "")
    .replace(/Please do NOT include any (?:pricing|pring) on invoices, receipts, price tags, or promotional materials inside or outside the package\.?/gi, "")
    .replace(/\*+\s*BLIND SHIPPING ONLY\s*\*+/gi, "")
    .trim();
  return cleaned;
};

const UpdatePurchaseOrder = (props) => {
  const {
    state,
    vendor,
    obj,
    line_items,
    setLineItems,
    subTotal,
    total,
    poNumber,
    terms,
    setTerms,
    shipping,
    setShipping,
    company,
    setCompany,
    vendorInstructions,
    setVendorInstructions,
    orderNote,
    setOrderNote,
    totalTaxAmount,
    setTotalTaxAmount,
    shippingCheckboxes,
    setShippingCheckboxes,
    handleUpdate,
    poDetails,
    shippingData,
    setShippingData,
    billingData,
    setBillingData,
    vendorPoNumber,
    setVendorPoNumber,
    itemModal,
    toggleItemModal,
    setOrderData,
    loader,
    purchaseOrderStatus,
    setPurchaseOrderStatus,
    orderData,
    freightBillingAccount,
    setFreightBillingAcc,
    setNewLineItems,

    pageLoader,
    dnhData,
    ingramData,
    distributorStockData,
    distributorStockLoading,
    soLineItems,
    addressType,
    setAddressType,
    signatureRequired,
    setSignatureRequired,
  } = useUpdatePurchaseOrder(props);
  if (pageLoader) {
    return (
      <div className="mt-4">
        <OrderDetailsSkeleton />
      </div>
    )
  }
  return (
    <>
      <>
        {itemModal && (
          <AddOrderItem
            toggle={toggleItemModal}
            modal={itemModal}
            setLineItems={setLineItems}
            line_items={line_items}
            orderData={orderData}
            setOrderData={setOrderData}
            setNewLineItems={setNewLineItems}
            soLineItems={soLineItems}
          />
        )}
        <PurchaseOrderDetailsHeader
          state={state}
          handleUpdate={handleUpdate}
          poNumber={poNumber}
          obj={obj}
          shippingCheckboxes={shippingCheckboxes}
          loader={loader}
          orderData={orderData}
        />
        <PageName title={"Purchase Details"} />
        {obj?.purchaseOrderStatus === "cancel" && (
          <Alert color="danger">Purchase Order has been Cancelled</Alert>
        )}
        <Row className="mb-2">
          <Col md={3}>
            <OrderBillingAddressCard
              title="Vendor Info"
              data={vendor?.billing[0]}
              shippingCheckboxes={shippingCheckboxes}
              setShippingCheckboxes={setShippingCheckboxes}
              billingData={billingData}
              setBillingData={setBillingData}
            />
          </Col>
          <Col md={3}>
            <OrderShippingAddressCard
              title="Ship To"
              data={shippingData}
              shippingCheckboxes={shippingCheckboxes}
              setShippingCheckboxes={setShippingCheckboxes}
              shippingData={shippingData}
              setShippingData={setShippingData}
            />
          </Col>
          <Col md={3}>
            <PurchaseOrderInformations
              terms={terms}
              setTerms={setTerms}
              company={company}
              setCompany={setCompany}
              shipping={shipping}
              setShipping={setShipping}
              freightBillingAcc={freightBillingAccount}
              setFreightBillingAcc={setFreightBillingAcc}
            />
          </Col>
          <Col md={3}>
            <POBasicInformations
              vendor={vendor}
              poNumber={poNumber}
              created_at={obj?.created_at}
              vendorPoNumber={vendorPoNumber}
              setVendorPoNumber={setVendorPoNumber}
              purchaseOrderStatus={purchaseOrderStatus}
              setPurchaseOrderStatus={setPurchaseOrderStatus}
              orderData={obj}
              addressType={addressType}
              setAddressType={setAddressType}
              signatureRequired={signatureRequired}
              setSignatureRequired={setSignatureRequired}
            />
          </Col>
          <div className="d-flex align-items-center justify-content-between my-1">
            <h4>Items</h4>
            <button
              className="text-primary rounded-0 px-2 py-1 border border-primary bg-white"
              onClick={toggleItemModal}

            >
              Add Item
            </button>
          </div>
          {line_items?.length > 0 ? (
            line_items?.map((item, index) => {
              const soItem = soLineItems?.find((so) =>
                (so?.sku && item?.sku && so.sku.toLowerCase() === item.sku.toLowerCase())
              );
              return (
                <div className="item_body_wrapper" key={item?._id || index}>
                  <PurchaseItemCard
                    key={item?._id || index}
                    index={index}
                    data={item}
                    line_items={line_items}
                    setLineItems={setLineItems}
                    imgURL={item?.image?.src}
                    poDetails={poDetails}
                    stockData={distributorStockData?.length > 0 ? distributorStockData : [...dnhData, ...ingramData]}
                    distributorStockLoading={distributorStockLoading}
                    maxSoQuantity={soItem ? parseInt(soItem.quantity) : undefined}
                  />
                </div>
              );
            })
          ) : (
            <Card className="items__notfound rounded-0 mt-3 ">
              <p>No Items Found </p>
              <img src={notFound} className="notFoundImage" alt="" />
            </Card>
          )}
          <Col md={8}>
            <Card className="border-0 shadow-sm h-100">
              <CardBody className="p-4 d-flex flex-column gap-4">
                <div>
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <div className="bg-primary-soft p-2 rounded-circle text-primary">
                      <FiFileText size={16} />
                    </div>
                    <h5 className="fw-bold text-dark mb-0 fs-15">Internal Note</h5>
                  </div>
                  <NotesCard
                    className="notesCard modern-notes border"
                    type="textarea"
                    height="80px"
                    placeholder="Add internal notes for this PO..."
                    value={orderNote}
                    handleChange={(e) => setOrderNote(e.target.value)}
                  />
                </div>
                <div>
                  <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap gap-2">
                    <div className="d-flex align-items-center gap-2">
                      <div className="bg-primary-soft p-2 rounded-circle text-primary">
                        <FiFileText size={16} />
                      </div>
                      <h5 className="fw-bold text-dark mb-0 fs-15">Vendor Instructions</h5>
                    </div>
                    <div className="form-check form-switch mb-0 d-flex align-items-center gap-2">
                      <input
                        className="form-check-input pointer"
                        type="checkbox"
                        id="toggleBlindShipNoteUpdatePO"
                        checked={isBlindShippingNotePresent(vendorInstructions)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setVendorInstructions(addBlindShippingNote(vendorInstructions));
                          } else {
                            setVendorInstructions(removeBlindShippingNote(vendorInstructions));
                          }
                        }}
                        style={{ width: "2.2em", height: "1.1em", cursor: "pointer" }}
                      />
                      <label
                        className="form-check-label mb-0 fw-semibold text-dark pointer"
                        htmlFor="toggleBlindShipNoteUpdatePO"
                        style={{ fontSize: "13px", cursor: "pointer", userSelect: "none" }}
                      >
                        Include Blind Shipping Note
                      </label>
                    </div>
                  </div>
                  <NotesCard
                    className="notesCard modern-notes border"
                    type="textarea"
                    height="80px"
                    placeholder="Instructions for the vendor..."
                    value={vendorInstructions}
                    handleChange={(e) => setVendorInstructions(e.target.value)}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col md={4}>
            <PurchaseTotalCard
              height={"100%"}
              totalTaxAmount={totalTaxAmount}
              subTotal={subTotal}
              total={total}
              setTotalTaxAmount={setTotalTaxAmount}
            />
          </Col>
          {
            orderData?.created_by && (
              <Col md={12} className="mb-0">
                <p className="text-end text-muted fs-12 mb-0">
                  Created By: {orderData?.created_by?.username ?? "Not Available"} at {moment(orderData?.created_at).format("MMM Do YYYY, h:mm a")}
                </p>
              </Col>)
          }
          {orderData?.updated_by && (<Col md={12} className="mb-0">
            <p className="text-end text-muted fs-12 mb-0">
              Updated By: {orderData?.updated_by?.username} at {moment(orderData?.updated_by?.updated_at).format("MMM Do YYYY, h:mm a")}
            </p></Col>
          )
          }
        </Row>
      </>
    </>
  );
};
export default UpdatePurchaseOrder;
